import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {OtpDeliveryMethod, LoginStep} from "../login.model";
import {NzFormModule} from "ng-zorro-antd/form";
import {OtpInputService} from "./otp-input.service";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NzInputModule} from "ng-zorro-antd/input";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzAlertModule} from "ng-zorro-antd/alert";
import {LoginService} from "../login.service";
import {TimerService} from "../../../shared/timer/timer.service";
import {Observable} from "rxjs";
import {NzProgressModule} from "ng-zorro-antd/progress";
import {map} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {QrCodeComponent} from "../../../shared/qr-code/qr-code.component";
import {SharedModule} from "../../../shared/shared.module";

@Component({
  selector: 'app-otp-input',
  standalone: true,
  imports: [CommonModule, NzFormModule, NzInputModule, ReactiveFormsModule, NzButtonModule, NzAlertModule, NzProgressModule, QrCodeComponent, SharedModule],
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.sass'],
  providers: [OtpInputService]
})
export class OtpInputComponent implements OnInit{
  @Input() selectedLevel2OtpGenerator: OtpDeliveryMethod;
  @Input() newOtpOnSmsWaitTime = environment.newOtpOnSmsWaitTime;
  @Input() newOtpOnEmailWaitTime = environment.newOtpOnEmailWaitTime;
  @Input() onLoginWithOtp: (otp: string, otpGenerator: OtpDeliveryMethod) => void ;

  readonly showForm$ = this.otpInputService.showForm$;
  readonly showRequireNewOtpButton$ = this.otpInputService.showRequireNewOtpButton$;
  readonly inputFormSpan$ = this.otpInputService.inputFormSpan$;
  readonly level2QrCode$ = this.otpInputService.level2QrCode$;

  readonly OtpDeliveryMethod = OtpDeliveryMethod;

  form: FormGroup;
  maxWaitTime: number;
  timer$: Observable<number>;

  constructor(
    private otpInputService: OtpInputService,
    private fb: FormBuilder,
    private loginService: LoginService,
    private timerService: TimerService
  ) {}

  ngOnInit(): void {
    this.otpInputService.selectedLevel2OtpGenerator = this.selectedLevel2OtpGenerator;
    this.form = this.fb.group({
      otp: ['', Validators.required]
    })
    this.maxWaitTime = this.timerService.getMaxWaitTime(this.selectedLevel2OtpGenerator);
    this.timer$ = this.timerService.getObservable(this.selectedLevel2OtpGenerator)?.pipe(
      map(value => Math.round((this.maxWaitTime - value) * 100 / this.maxWaitTime))
    );
  }

  onBack() {
    this.loginService.step = environment.showAuthenticationWithApp ? LoginStep.Level2Recognition : LoginStep.UsernameAndPassword;
  }

  otpFormatTimer = (percent: number): string => `${this.maxWaitTime - Math.round(percent *  this.maxWaitTime / 100)}`;


  onNewOtpClick() {
    this.loginService.sendOtp(this.selectedLevel2OtpGenerator);
  }

  login() {
    if (this.form.invalid) {
      return;
    }
    this.onLoginWithOtp(this.form.value.otp, this.selectedLevel2OtpGenerator);
  }
}
